import { render, staticRenderFns } from "./TrackerDataTableExpandRow.vue?vue&type=template&id=a07de442&scoped=true"
import script from "./TrackerDataTableExpandRow.js?vue&type=script&lang=js&external"
export * from "./TrackerDataTableExpandRow.js?vue&type=script&lang=js&external"
import style0 from "./TrackerDataTableExpandRow.vue?vue&type=style&index=0&id=a07de442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07de442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VCard})
